import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const EndCTASection = styled.section`
  background: radial-gradient(
    ellipse 90% 120% at 50% 0%,
    #0f555c 0%,
    #0a282d 46%,
    ${homeColor.bg} 85%
  );
  text-align: center;
  border-top: 1px solid ${homeColor.carbon};
  padding: 50px 0;

  ${screen.md} {
    padding: 60px 0;
  }

  ${screen.lg} {
    padding: 80px 0;
  }

  ${screen.xxlg} {
    padding: 100px 0;
  }
`;

export const Title = styled.h2`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.1;
  font-size: 32px;
  margin: 0 auto 16px;
  max-width: 590px;
  color: ${homeColor.white};

  ${screen.md} {
    font-size: 38px;
    max-width: 700px;
  }

  ${screen.lg} {
    font-size: 44px;
    max-width: 810px;
  }

  ${screen.xxlg} {
    font-size: 50px;
    max-width: 920px;
  }
`;

export const TitleHighlight = styled.span`
  color: ${homeColor.green};
`;

export const Copy = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.white};
  font-size: 17px;
  margin: 0 auto 24px;
  max-width: 435px;
  line-height: 1.55;
`;

export const CtaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
`;
